import MaskResolver from "./maskResolver";

export default class MaskService {
  static toMask(type, value, decimals) {
    return MaskResolver.resolve(type).getValue(value, decimals);
  }

  static isValid(type, value, settings) {
    return MaskResolver.resolve(type).validate(value, settings);
  }

  static removeMaskDecimal(value = "", fixed = 2) {
    return parseFloat(
      parseFloat(value.replace(/\./g, "").replace(",", ".")).toFixed(fixed)
    );
  }

  static changeUStoBR = (value = "") => {
    if (value.length > 0) {
      value = value.replace(",", "");

      return value.replace(".", ",");
    }
    return value;
  };

  static dateYmdToDmy = (value = "") => {
    return value.split("-").reverse().join("/");
  };
}
